import { Link } from '@tbitop/mobile-app';
import type { InternalUrl } from '@tbitop/routing';
import { Card, Header4, Paragraph, ShortDate, TagNeutral } from '@tbitop/ui';
import { CalendarBlank } from 'phosphor-react';
import { useId } from 'react';

type KampagnenListItemProps = {
  kampagne: {
    aufgabenTyp: string;
    aufgabenTitel: string;
    faelligkeit: string | null;
    name?: string | null;
  };
  href: string | InternalUrl;
};

export const KampagnenListItem = ({ kampagne, href }: KampagnenListItemProps) => {
  const headerId = useId();

  if (!kampagne) {
    return null;
  }

  return (
    <li aria-labelledby={headerId}>
      <Link href={href}>
        <Card displayAsClickable className="flex flex-col gap-200">
          <TagNeutral text={kampagne.aufgabenTyp} className="self-start"/>
          <Header4 id={headerId}>{kampagne.aufgabenTitel}</Header4>
          {kampagne.name && <Paragraph>{kampagne.name}</Paragraph>}
          {kampagne.faelligkeit ? <DueDate date={kampagne.faelligkeit} /> : null}
        </Card>
      </Link>
    </li>
  );
};

type DueDateProps = {
  date: string;
};

const DueDate = ({ date }: DueDateProps) => (
  <Paragraph className="flex items-center text-tds-color-copy-on-light-50 gap-50">
    <CalendarBlank size={14} />
    <ShortDate date={date} />
  </Paragraph>
);
